/**
 * Prompt Library — auto-discovered from .md files.
 *
 * HOW TO ADD A NEW PROMPT:
 *   1. Create a new .md file in this directory (e.g. my-prompt.md)
 *   2. Add YAML frontmatter: id, title, category, difficulty, tags,
 *      description, whenToUse, variables, tips
 *   3. Write the prompt template as the markdown body
 *   4. Add <!-- EXAMPLE_OUTPUT --> marker, then the example output
 *   5. Done — it's auto-discovered, no imports needed
 *
 * HOW TO REMOVE A PROMPT:
 *   Delete the .md file. That's it.
 *
 * Categories and difficulties are in _categories.js
 */

export { categories, difficulties } from './_categories';

const modules = import.meta.glob('./*.md', { eager: true });

const prompts = Object.values(modules)
  .map((mod) => mod.default)
  .sort((a, b) => a.category.localeCompare(b.category) || a.title.localeCompare(b.title));

export default prompts;
